import { ol_extent, ol_Feature, ol_Overlay } from "@omnia/exports/openlayers";
import { ImportDocument } from "../documents";

/**
 * Creates an OpenLayer overlay for a map feature
 * This overlay is used to display a picture associated with the feature on the map
 *
 * Note: This function was moved from the Layers module, and to the shared map components, so as to be reusable
 * in the Field Diary module. As such, it still has implicit dependencies on the Layers module, through the omnia-maplayers-picture-popup
 * component. This works because the Layers module is a core module, and always available, but should be improved at some point
 */
export function createPictureOverlay($scope: ng.IScope, $compile: ng.ICompileService, feature: ol_Feature, picture: ImportDocument) {

    const eltScope = $scope.$new(true)
    eltScope["picture"] = picture

    const elt = $compile("<omnia-maplayers-picture-popup></omnia-maplayers-picture-popup>")(eltScope);

    const geom = feature.getGeometry();
    const coordinates = (<any>geom).getInteriorPoint ? (<any>geom).getInteriorPoint().getFirstCoordinate() : ol_extent.getCenter(feature.getGeometry().getExtent());

    const overlay = new ol_Overlay({
        element: elt[0],
        position: coordinates,
        stopEvent: true,
        positioning: "center-center",
        offset: [0, -27]
    });

    const togglePopup = (open?: boolean) => {
        const t = eltScope["togglePopup"]
        return t && t(open)
    }

    return { overlay, togglePopup }

}
